module.exports = {
  getFlag() {
    return true
  },
}
